import { render, staticRenderFns } from "./EmpPriorAuthRules.vue?vue&type=template&id=20332bb5&"
import script from "./EmpPriorAuthRules.vue?vue&type=script&lang=js&"
export * from "./EmpPriorAuthRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports